module.exports = __webpack_public_path__ + "img/1.d01319d4.jpg";